// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

common.View.create('website::layouts.main.Sponsor', {

    onDOMLoad() {
        const sponsorsCount = this.element.find('.swiper-container').data('count');

        if (sponsorsCount >= 8) {
            this.initSlider();
        }
    },

    initSlider() {
        new Swiper('.swiper-container', {
            speed: 3000,
            loop: true,
            autoplay: {
                delay: 0,
                reverseDirection: false,
                disableOnInteraction: false,
            },
            spaceBetween: 64,
            allowTouchMove: false,
            initialSlide: 2,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                }
            },
        });
    }
});
